// @ts-nocheck
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { AddressComponent } from '../address/address.component';
import FieldsConfig from '../address/address.fields';

@Component({
  selector: 'lbca-address-list',
  templateUrl: './address-list.component.html',
  styleUrl: './address-list.component.scss',
  imports: [AddressComponent, IconComponent],
})
export class AddressListComponent implements OnInit {
  public addressList = [
    {
      index: 0,
      street: '',
      city: '',
      state: '',
      neighborhood: '',
      cep: '',
      complement: '',
      number: '',
      type: '',
    },
  ];

  ngOnInit(): void {
    this.validateCallbackEmitter.emit(this.validate);
  }

  public isTouched: boolean = true;
  public hasError: boolean = false;
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isLabeled: boolean = true;

  public labelValue: string = 'Endereço';
  public helperTextValue: string = '';

  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set value(value: any) {
    this.addressList = value;
  }
  @Input() displayFields!: { [key: string]: boolean };

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  public changeValue($event, address) {
    // gambiarra que veio do .html
    address = $event;

    const dataFormated: any[] = [];
    this.addressList.forEach((item) => {
      const newItem = { ...item };
      delete (newItem as any).index;
      let erro = false;
      for (const [key, value] of Object.entries(item)) {
        if (this.displayFields && Object.prototype.hasOwnProperty.call(this.displayFields, key)) {
          if (this.displayFields[key] && value == '') erro = true;
        } else if (FieldsConfig[key] && FieldsConfig[key].required) {
          if (FieldsConfig[key] && value == '') erro = true;
        }
      }
      if (!erro) dataFormated.push(newItem);
    });

    if (dataFormated.length > 0) this.changeEmmiter.emit(dataFormated);
    else this.changeEmmiter.emit('');
  }

  public deleteAddress(address) {
    if (this.addressList.length == 1 && this.isRequired) {
      this.addressList = [];
      this.addNewAddress();
      return;
    }
    this.addressList.splice(address.index, 1);
    for (let index = 0; index < this.addressList.length; index++)
      this.addressList[index].index = index;
  }

  public validadeLastAddressRegistered() {}

  public addNewAddress() {
    if (this.validateRegister()) this.pushAddress();
  }

  public validateRegister() {
    const list = this.addressList[this.addressList.length - 1];
    if (this.addressList.length == 0) return true;
    if (this.displayFields) {
      if (list.street && list.city && list.state && list.neighborhood && list.cep && list.number)
        return true;
    } else {
      if (
        list.street &&
        list.city &&
        list.state &&
        list.neighborhood &&
        list.cep &&
        list.number &&
        list.type
      )
        return true;
    }
    return false;
  }

  public pushAddress() {
    this.addressList.push({
      index: this.addressList.length,
      street: '',
      city: '',
      state: '',
      neighborhood: '',
      cep: '',
      complement: '',
      number: '',
      type: '',
    });
  }

  public validate = () => {
    this.validateList.forEach((fn) => fn());
  };

  private validateList: any[] = [];

  public setFieldValidateCallback(fn) {
    this.validateList.push(fn);
  }
}
